import React from "react";
//import classes from './MenuItem.module.css';

const contactMenuItem = (props) => <span>{props.children}</span>;

export default contactMenuItem;
